// extracted by mini-css-extract-plugin
module.exports = {"footer":"ContactPanel_footer__ErUF_","stickyNav":"ContactPanel_stickyNav__8_A20","fixedLeftbar":"ContactPanel_fixedLeftbar__OJFoy"};